module.exports = __webpack_public_path__ + "static/img/preview-05.1b05a0fa.webp";